import { Form } from "@angular/forms";

export class UploadFileModel {
    ProductId: number;
    ImageName: string;
    FileDescription: string;
    Image: any;
    FileTitle: string ;
    FileType: string ;
}

export class FileModel{
    fileUrl: string[] = [];
    fileTitle: string;
    ImageName:string;
    Image: any[] = [];
}